import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class RouteInterceptor implements HttpInterceptor {

  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Get the current Angular route (e.g., /management/quotations/new)
    const currentRoute = this.router.url;

    console.log('🔍 HTTP Interceptor - Current Route:', currentRoute);
    console.log('🔍 HTTP Interceptor - Request URL:', req.url);
    console.log('🔍 HTTP Interceptor - Request Body BEFORE:', req.body);

    // Skip modification for FormData (multipart/form-data requests)
    if (req.body instanceof FormData) {
      console.log('🔍 HTTP Interceptor - FormData detected, skipping body modification');
      // Add RequestInternalURL as a FormData field instead
      req.body.append('RequestInternalURL', currentRoute);
      return next.handle(req);
    }

    // Clone the request and add the RequestInternalURL to the body
    if (req.body && typeof req.body === 'object') {
      const modifiedBody = {
        ...req.body,
        RequestInternalURL: currentRoute
      };

      console.log('🔍 HTTP Interceptor - Request Body AFTER:', modifiedBody);

      const clonedRequest = req.clone({
        body: modifiedBody
      });

      return next.handle(clonedRequest);
    }

    console.log('⚠️ HTTP Interceptor - Skipped (no body or not an object)');
    return next.handle(req);
  }
}

